import Http from "../../../utils/restClient";

export default class TaxesApi {
	public static GetTaxesList() {
		return Http.axios().get("/api/v1/taxes");
	}
}
